import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internetmunicipal',
  templateUrl: './internetmunicipal.component.html',
  styleUrls: ['./internetmunicipal.component.css']
})
export class InternetmunicipalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
